import { firestoreTimestampToDate, isDate } from "../utils/obejct-diff"

export interface IDigatag {
    identifier: string
    governmentId: string
    gameRecordId: string
    contextId: string
    state?: string
    updateTimestamp?: Date
    activationTimeStamp: Date
    timeStamp: Date
    expiryDate: Date
}

export const checkValidUUID = (str: string): boolean => {
    const regex = new RegExp("^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$", "i") 
    const match = str.match(regex)
    return match?.length == 1
}

export class Digatag {

    public static className = "Digatag"
    public className = "Digatag"

    identifier: string|undefined
    contextId: string|undefined
    governmentId: string|undefined
    gameRecordId: string|undefined
    state: string|undefined
    activationTimeStamp: Date|undefined
    expiryDate: Date|undefined
    timeStamp: Date|undefined
    updateTimestamp: Date|undefined

    constructor() {}

    setFromAny(element: any) {
        Object.assign(this, element)
        // dates... 
        const {updateTimestamp, timeStamp, expiryDate, activationTimeStamp} = element
        this.timeStamp = timeStamp ? isDate(timeStamp) ? timeStamp : firestoreTimestampToDate(timeStamp) : this.timeStamp
        this.expiryDate = expiryDate ? isDate(expiryDate) ? expiryDate : firestoreTimestampToDate(expiryDate) : this.expiryDate
        this.activationTimeStamp = activationTimeStamp ? isDate(activationTimeStamp) ? activationTimeStamp : firestoreTimestampToDate(activationTimeStamp) : this.activationTimeStamp
        this.updateTimestamp = updateTimestamp ? isDate(updateTimestamp) ? updateTimestamp : firestoreTimestampToDate(updateTimestamp) : this.updateTimestamp
    }

    searchFilter(filter: string): boolean {
        const str = `${this.identifier}`.toLowerCase()
        return str.includes(filter)
    }
}